import { Model } from '@/models/Model';

export class Setting extends Model {
  protected $name: string = 'Setting';
  protected $endpoint: string = '/settings';
  protected $fillable: string[] = [];

  public id?: string;
  public key?: string;
  public value?: string | boolean;
  public created_at?: string;
  public updated_at?: string;

  public resolvePrimaryKey(): string {
    return '';
  }
}

export interface Language {
  language: string;
  locale: string;
}
